import { createFileRoute } from '@tanstack/react-router';

import { SizeSetsPage, sizeSetsQueryOptions } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/size-sets/')({
  staticData: { tours: ['dictionary.size-sets'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...sizeSetsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: SizeSetsPage,
});
